import Base from 'app/views/base';

import EventsView from './events';
import WebhooksView from './webhooks';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'webhooks-and-events',

  initialize({ query = {} }) {
    this.addSubview('webhooksView', '#webhooks_view', new WebhooksView({}));
    this.addSubview('eventsView', '#events_view', new EventsView({ query }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/webhooks_and_events/index.js